import {ssrLazy} from 'ssr/lazy';
export const SalesCardsLazy = ssrLazy(() => import(/* webpackChunkName: "salesCards" */ '.'));
